import { styled } from '@mui/material/styles';
import SingleColumn from 'components/ScalarSpreadsheet/components/single-column/SingleColumn';

export const StyledTotalsColumn = styled(SingleColumn) (( { theme }) => ({
  borderLeft: `5px solid ${theme.palette.grey[300]}`,
}));
